import support from './support/index';
import selfInspectionManual from './selfInspectionManual/index';
import selfRepair from './selfRepair/index';
import vehicleSupport from './vehicleSupport/index';
import knowledge from './knowledge/index';
import seo from './seo/index';
import onlineRepair from './onlineRepair/index';
import search from './search/index';
import serviceOutlets from './serviceOutlets/index';
import error from './error/index';
import { useLocalData } from '../json/main';
import mailRepair from './mailRepair/index';
import common from './common/index';
import recall from './recall/index';
import international from './international/index';
import accessoryPrices from './accessoryPrices/index';
import cocAuthentication from './cocAuthentication/index';

const langData = {
  support,
  selfInspectionManual,
  selfRepair,
  vehicleSupport,
  knowledge,
  seo,
  onlineRepair,
  search,
  serviceOutlets,
  error,
  mailRepair,
  common,
  recall,
  international,
  accessoryPrices,
  cocAuthentication
};
const langs = [
  'en',
  'zh',
  'de',
  'it',
  'es',
  'fr',
  'ja',
  'ko',
  'nl',
  'pl',
  'zh_hant',
  'vi',
  'tr',
  'ru'
];

// const langs = ['en', 'zh', 'de', 'it', 'es'];
// const langs = useLocalData().siteList.map((item: any) => item.lang);

function getLangData() {
  const data: any = {};
  langs.map(item => {
    const dict: any = {};
    for (const [key, value] of Object.entries(langData)) {
      dict[key] = value[item as keyof object];
    }
    data[item] = dict;
  });
  return data;
}

export default getLangData();
